import { ChangeDetectionStrategy, Component, input } from '@angular/core';
import { MatIconModule } from '@angular/material/icon';

@Component({
  selector: 'rv-badge',
  imports: [MatIconModule],
  template: `
    @if (shape() === 'icon' && icon()) {
      <mat-icon [svgIcon]="icon()" class="thin" />
    } @else {
      @if (icon()) {
        <mat-icon [svgIcon]="icon()" class="small" />
      }
      @if (text()) {
        <span class="rv-badge-span">{{ text() }}</span>
      }
    }
  `,
  styleUrls: ['./rv-badge.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  host: {
    '[class]': '"rv-badge rv-badge--" + shape() + " rv-badge--" + color()',
    '[attr.aria-label]': 'ariaLabel() || null',
  },
})
export class RvBadgeComponent {
  shape = input<'chip' | 'icon'>('chip');

  /** Screen reader label when the badge is icon-only (no visible text). */
  ariaLabel = input<string | null>(null);

  color = input<
    | 'green'
    | 'yellow'
    | 'red'
    | 'blue'
    | 'gray'
    | 'purple'
    | 'sky'
    | 'amber'
    | 'orange'
  >('gray');

  icon = input<string | null>(null);

  text = input<string>('');
}
